/** 合同列表 查询*/
export const API_POST_CONTRACT_LIST = {
  url: 'supplier/contract/list',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 合同列表 查看协议*/
export const API_GET_CONTRACT_PREVIEW = {
  url: 'supplier/contract/preview',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/** 合同列表 签署*/
export const API_GET_CONTRACT_SIGN = {
  url: 'supplier/contract/sign',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/** 合同列表 待供应商签署数量*/
export const API_GET_CONTRACT_COUNT = {
  url: 'supplier/contract/count',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 食安证件临期数量*/
export const API_GET_CONTRACT_TYPE_COUNT = {
  url: 'certificate/manage/type/expire/count',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/** 待传凭证直送单、驳回待传凭证直送单数量*/
export const API_POST_API_UPLOAD_VOUCHER_COUNT = {
  url: 'api/upload/voucher/count',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 合同列表 甲方公司名称*/
export const API_GET_CONTRACT_COMPLANY_LIST = {
  url: 'supplier/contract/complany/list',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/** 合同列表 下载协议*/
export const API_POST_CONTRACT_DOWNLOAD = {
  url: 'supplier/contract/downLoad',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};
